import React from "react";

export default class FolderList extends React.Component {

    constructor(props) {
        super(props);
    }

    dragfolderstart(e) {
        e.dataTransfer.setData("text/plain", e.target.id);
    }


    render() {
        if(this.props.list === "folders") {       
            const thefolders = window.apm.serialized.folders;
            const folders = [];
            let thestyle;
            const foldertype = this.props.type;
            for (var type in thefolders) {                
                if (type === foldertype+"s") {
                    thefolders[type].sort((a,b) => (a.name > b.name) ? 1 : -1);
                    for (var i = 0; i < thefolders[type].length; i++) {
                        var node = thefolders[type][i];
                        if(this.props.currentfolder === node.id) {
                            thestyle = {backgroundColor: "rgba(26, 158, 232, 0.6)"};
                        } else {
                            thestyle = {};
                        }
                        folders.push(
                            <li
                                onContextMenu={(e) => this.props.context.foldercontextmenu(e)}  
                                id={node.id+"_anchor"} 
                                className={"jstree-node  jstree-leaf"} 
                                key={node.id}
                                style={{ marginBottom: "3px", paddingLeft: '8px' }}>
                                    <a style={thestyle} 
                                       className={"jstree-anchor"} 
                                       href={"#"} 
                                       id={node.id} 
                                       name={node.name}
                                       draggable={true}
                                       onMouseOut={(e)=>this.props.context.removehighlight(e.target)} 
                                       onMouseOver={(e)=>this.props.context.gethighlight(e.target)} 
                                       onClick={(e)=>this.props.context.pickFolder(e.target)} 
                                       onDrop={() => this.props.context.folderdrop(event)} 
                                       onDragOver={() => this.props.context.dragfolder(event,this.props.currentfolder)} 
                                       onDragLeave={(e)=>this.props.context.removehighlight(e.target)}
                                       >
                                        <i className={"jstree-icon jstree-themeicon jstree-themeicon-custom"} 
                                            role={"presentation"} 
                                            style={{backgroundImage: "url('/lib/feather/folder.svg')", backgroundPosition: "center center", backgroundSize: "auto"}}></i>
                                        {node.name}
                                    </a>
                            </li>
                        );
                    }
                } 
            }
            return(folders);
        }
        if(this.props.list === "nodes") { 
            const nodetype = this.props.type;
            const thenodes = window.apm.serialized.components[nodetype+"s"];
            const nodes = [];
            const folderchildren = this.props.folderChildren;
            thenodes.sort((a,b) => (a.name > b.name) ? 1 : -1);
            for (var i = 0; i < thenodes.length; i++) {
                let node = thenodes[i];
                let match = false;
                let icon = node.props.iconClass;
                for(var child in folderchildren[this.props.currentfolder]) {
                    if(this.props.currentfolder !== "uncategorized" && folderchildren[this.props.currentfolder][child] === node.id) {
                        match = true;
                    }
                }
                if(this.props.currentfolder === "uncategorized") {
                    for(var child in folderchildren) {
                        for(var p = 0; p < folderchildren[child].length; p++) {
                            if(folderchildren[child][p] === node.id) {
                                match = true;
                            }
                        }
                    }
                }
            
                if(match === false && this.props.currentfolder === "uncategorized") {
                    nodes.push(
                        <li 
                            id={node.id} 
                            className={"jstree-node  jstree-leaf"} 
                            key={node.id}
                            style={{paddingLeft: '8px'}}>
                            <a 
                            draggable={true} 
                            onDragStart={() => this.dragfolderstart(event)} 
                            className={"jstree-anchor"} href={"#"} id={node.id+"_anchor"} name={node.name}>
                                <i 
                                    className={"jstree-icon jstree-themeicon jstree-themeicon-custom"} 
                                    role={"presentation"} 
                                    style={{backgroundImage: "url('/lib/feather/"+icon+".svg')", backgroundPosition: "center center", backgroundSize: "auto"}}>
                                </i>
                                {node.name}
                            </a>
                        </li>
                    );
                } else if(match === true && this.props.currentfolder !== "uncategorized") {
                    nodes.push(
                        <li 
                            id={node.id} 
                            className={"jstree-node  jstree-leaf"} 
                            key={node.id}
                            style={{paddingLeft: '8px'}}>
                            <a 
                                data-dragid={node.id}
                                draggable={true} 
                                onDragStart={() => this.dragfolderstart(event)} 
                                className={"jstree-anchor rd"} href={"#"} id={node.id+"_anchor"} name={node.name}>
                                <i className={"jstree-icon jstree-themeicon jstree-themeicon-custom"} 
                                    role={"presentation"} 
                                    style={{backgroundImage: "url('/lib/feather/"+icon+".svg')", backgroundPosition: "center center", backgroundSize: "auto"}}>
                                    </i>
                                {node.name}
                            </a>
                        </li>
                    );
                }
            }
            return(nodes)
        }
    }
}